import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { companyService } from '../../services/companies/companyService'
import { CreateCompanyPayload, UpdateCompanyPayload } from '../../types/company'
import { CompanyDetail } from '../../types/company'

export const useCompanies = (params?: { search?: string; status?: string }) => useQuery({
  queryKey: ['companies', params],
  queryFn: () => companyService.list(params),
})

export const useCompany = (id: string) => useQuery({
  queryKey: ['companies', id],
  queryFn: () => companyService.get(id),
  enabled: Boolean(id),
})

export const useCreateCompany = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (payload: CreateCompanyPayload) => companyService.create(payload),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['companies'] }),
  })
}

export const useUpdateCompany = (id: string) => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (payload: UpdateCompanyPayload) => companyService.update(id, payload),
    onSuccess: (company) => {
      queryClient.setQueryData<CompanyDetail>(['companies', id], (previous) => ({
        ...company,
        uom_editable: previous?.uom_editable ?? false,
      }))
      queryClient.invalidateQueries({ queryKey: ['companies'] })
    },
  })
}

export const useCompanyStatus = (id: string) => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (status: 'active' | 'suspended') => companyService.setStatus(id, status),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['companies'] }),
  })
}
